var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.089,
    height: 21.392,
    viewBox: "0 0 21.089 21.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_forward_FILL1_wght300_GRAD0_opsz48",
    d: "M19.088,30.105a.87.87,0,0,1,0-1.145l8.335-8.335H9.573a.823.823,0,1,1,0-1.646H27.423l-8.335-8.335a.774.774,0,0,1-.215-.572.9.9,0,0,1,.215-.608.87.87,0,0,1,1.145,0l9.587,9.623a.791.791,0,0,1,.25.322,1.05,1.05,0,0,1,.072.393,1.1,1.1,0,0,1-.072.376.768.768,0,0,1-.25.34l-9.587,9.623a.719.719,0,0,1-.572.2A.836.836,0,0,1,19.088,30.105Z",
    transform: "translate(-9.25 30.142) rotate(-90)",
    fill: "#c3dad4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.05365e9a4958d72048063950e2ba0bce.svg";
export { ForwardRef as ReactComponent };